<mat-horizontal-stepper #pasos>
  <mat-step>
    <ng-template matStepLabel>overview</ng-template>
    <vista-gen (cambiaPaso)="cambiaPaso($event)"></vista-gen>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>vista correos</ng-template>
    <correos (cambiaPaso)="cambiaPaso($event)" (enviaDatosEditor)="enviaInfoEditor($event)"></correos>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>edicion correos</ng-template>
    <editorEmail (cambiaPaso)="cambiaPaso($event)" [entradaDatos]="enviaDatosEditor.asObservable()"></editorEmail>
  </mat-step>
</mat-horizontal-stepper>
